import { c as _c } from "react/compiler-runtime";
import { getOsType } from '@core/utils';
import { useEffect } from 'react';
import { useShallow } from 'zustand/react/shallow';
import { detectWebviewType } from '@/utils/webviewType';
import { useDeviceInfoStore } from './useDeviceInfoStore';
export const useMountDeviceInfoStore = () => {
  const $ = _c(6);
  const [setIsMounted, setWebviewType, setOsType, setViewportType] = useDeviceInfoStore(useShallow(_temp));
  let t0;
  let t1;
  if ($[0] !== setIsMounted || $[1] !== setOsType || $[2] !== setViewportType || $[3] !== setWebviewType) {
    t0 = () => {
      const {
        userAgent
      } = navigator;
      setOsType(getOsType());
      setViewportType(/Mobile/.exec(userAgent) ? "mobile" : "desktop");
      const webviewTypeByUserAgent = detectWebviewType(userAgent);
      if (webviewTypeByUserAgent) {
        setWebviewType(webviewTypeByUserAgent);
      }
      setIsMounted(true);
    };
    t1 = [setIsMounted, setOsType, setViewportType, setWebviewType];
    $[0] = setIsMounted;
    $[1] = setOsType;
    $[2] = setViewportType;
    $[3] = setWebviewType;
    $[4] = t0;
    $[5] = t1;
  } else {
    t0 = $[4];
    t1 = $[5];
  }
  useEffect(t0, t1);
};
function _temp(state) {
  return [state.setIsMounted, state.setWebviewType, state.setOsType, state.setViewportType];
}